import React, { useEffect, useState } from "react";
import { flagIcons } from "../consts";

export const PolicyStatusIcons = ({claimDetailCookie}) => {
   const [data, setData] = useState(claimDetailCookie);
  useEffect(() => {
    setData(claimDetailCookie)
  },[claimDetailCookie])
  const flagIds = data?.flags?.map((flag) => flag.flagId) || [];

  if (!Array.isArray(flagIds) || flagIds.length === 0) {
    return (
      <div className="d-flex flex-row flex-nowrap align-items-center gap-1 lh-1 mt-1">
        <span className="text-muted">--</span>
      </div>
    );
  }

  return (
    <div className="d-flex flex-row flex-nowrap align-items-center gap-1 lh-1 overflow-auto">
      {flagIds.map((flagId) => {
        const flag = typeof flagId === "string" ? Number(flagId) : flagId;
        const flagConfig = flagIcons[flag];
        if (!flagConfig) return null;
        const { label, img } = flagConfig;
        if (!img) return null;

        return (
          <span
            key={flag}
            className={`flag-pill flag--${flag} d-inline-flex align-items-center px-2 py-1 mt-2 rounded-pill`}
            aria-label={label}
            title={label}
          >
            <img src={img} alt="" className="flag-icon me-1" />
            <span className="fw-semibold">{label}</span>
          </span>
        );
      })}
    </div>
  );
}
